import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { fetchCourses } from "../../../../../../utils/Apis";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const StudentCoursesCard = () => {
  const dispatch = useDispatch();

  const studentDetails = useSelector(
    (state) => state.user.data?.studentDetails
  );

  const courseIds =
    studentDetails?.courses?.map((c) =>
      typeof c.course === "object" ? c.course._id : c.course
    ) || [];

  const allCourses = useSelector((state) => state.data.courses?.courses || []);
  const loading = useSelector((state) => state.data.coursesLoading);
  const error = useSelector((state) => state.data.coursesError);

  useEffect(() => {
    if (allCourses.length === 0) {
      dispatch(fetchCourses());
    }
  }, [dispatch, allCourses.length]);

  const matchedCourses = useMemo(() => {
    const courseMap = allCourses.reduce((acc, course) => {
      acc[course._id] = course;
      return acc;
    }, {});
    return courseIds.map((id) => courseMap[id]).filter(Boolean);
  }, [courseIds, allCourses]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: matchedCourses.length > 1,
    autoplaySpeed: 6000,
    arrows: false,
  };

  const renderCourseCard = (course) => (
    <div className="p-2">
      <div className="bg-white text-black rounded-xl p-2 shadow-lg">
        <h5 className="text-xl font-bold mb-2">{course.name}</h5>
        <p className="text-sm">
          <strong>Course ID:</strong> {course.CourseId || course._id}
        </p>
        <p className="text-sm">
          <strong>Duration:</strong>{" "}
          {course.duration
            ? `${course.duration.value} ${course.duration.unit}`
            : "N/A"}
        </p>
        <p className="text-sm">
          <strong>Fee:</strong> ₹
          {course.feeStructure?.finalFee?.toLocaleString("en-IN") || "N/A"}
        </p>
      </div>
    </div>
  );

  return (
    <div className="w-full max-w-xl bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-500 text-white rounded-2xl shadow-2xl p-6">
      <h4 className="text-lg font-semibold uppercase tracking-wide text-center">
        Enrolled Courses
      </h4>

      <div>
        {loading ? (
          <p className="text-center animate-pulse">Loading courses...</p>
        ) : error ? (
          <p className="text-center text-red-200">Error loading courses.</p>
        ) : matchedCourses.length === 0 ? (
          <p className="text-center">No Courses Enrolled</p>
        ) : (
          <Slider {...settings}>
            {matchedCourses.map((course, index) => (
              <div key={index}>{renderCourseCard(course)}</div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default StudentCoursesCard;

// make it optimized, ui/ux better, responsive for all devices
